import React from 'react';
import EditButton from './EditButton';
import { userProfileCopy } from '../../../copy/advisor-dashboard/user-profile.json';

export default function UserProfileInformation(props) {
  const {
    label,
    edit,
    handleEdit,
    handleCancel,
    input,
    primaryColor,
    onChange,
    propValue,
    isError,
    onBlur,
    editable,
  } = props;

  return (
    <div className="grid-item">
      <span className="form-input">
        {label}
        {edit ? (
          <EditButton
            primaryColor={primaryColor}
            onChange={() => {
              handleEdit(false);
              handleCancel(propValue);
            }}
          >
            {userProfileCopy.buttons.button4}
          </EditButton>
        ) : (
          editable && (
            <EditButton
              primaryColor={primaryColor}
              onChange={() => handleEdit(true)}
            >
              {userProfileCopy.buttons.button2}
            </EditButton>
          )
        )}
      </span>
      {edit ? (
        <input
          className={
            isError ? 'edit-profile-input error' : 'edit-profile-input'
          }
          key={propValue}
          name={propValue}
          onChange={onChange}
          onBlur={onBlur}
          id={propValue}
        />
      ) : (
        <span className="user-grid-item">{input}</span>
      )}
    </div>
  );
}
